import type { PermissionType } from "../schemas/PermissionsSchemas.ts";
import { fetchAndCollate } from "../util/index.ts";
import type {
  GetListRequestType,
  GetListResponseType,
  ResourceAdapterType,
} from "../util/index.ts";
import { restAPI } from "./api.ts";

export const PermissionsAdapter: ResourceAdapterType<PermissionType> = {
  /**
   * Get permissions list. Only returns permissions whose mapped feature flag is
   * enabled globally and for the caller's company (`isFeatureEnabled` on the API).
   * @see https://staging-carbon-hub-api.s3.us-west-2.amazonaws.com/openapi/index.html#/permissions/list_permissions
   * @returns the list of permissions
   */
  getList: ({
    page,
    pageSize,
    sortBy,
    sortDirection,
    filters,
  }: GetListRequestType<{ name: string }>) =>
    fetchAndCollate<PermissionType>(
      ({ page, pageSize }) =>
        restAPI.nodeAPI.GET<GetListResponseType<PermissionType>>({
          endpoint: "/permissions",
          query: {
            page,
            page_size: pageSize,
            sort_by: sortBy,
            sort_direction: sortDirection,
            isFeatureEnabled: true,
            ...(filters?.name ? { name: filters.name } : {}),
          },
        }),
      page,
      pageSize
    ),
  getOne: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  getMany: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  createOne: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  createMany: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  updateOne: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  updateMany: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  deleteOne: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
  deleteMany: () =>
    Promise.reject({
      success: false,
      message: "Method not implemented",
    }),
};
